import prepare from '@/routes_new/outer/interview/landing/prepare';
import visibility from '@/routes_new/outer/interview/visibility';
import refuse from '@/routes_new/outer/interview/refuse';
import interview_talentq from '@/routes_new/outer/interview/landing/talentq';
import interview_talentq_routes from '@/routes_new/outer/interview/landing/talentq/routes.js';
import videoresumeFeedback from '@/components/interview/EndVideoresume';
const InterviewVideoResult = () =>
  import('@/routes_new/outer/interview/video_result/InterviewVideoResult');

export default [
  {
    path: 'r/:token',
    name: 'open-registration',
    component: prepare,
    props: route => ({
      token: route.params.token,
      page_type: 'landing'
    }),
    meta: {
      title: 'pageTitles.routes.openRegistration',
      customInputFields: true,
      contentWrapperVideointerview: true,
      is_adaptive: true,
      isOuter: true
    },
    alias: '/open-registration/:token'
  },
  {
    path: 'talentq/:token',
    name: 'interview-talentq',
    component: interview_talentq,
    props: true,
    children: interview_talentq_routes
  },
  {
    path: 'interviews/:token',
    name: 'interview',
    component: prepare,
    props: route => ({
      token: route.params.token,
      fromRegistration: route.params.fromRegistration,
      page_type: 'interview'
    }),
    meta: {
      title: 'pageTitles.routes.interviews.root',
      contentWrapperVideointerview: true,
      is_adaptive: true,
      isOuter: true
    },
    children: [
      {
        path: 'hide',
        component: visibility,
        name: 'interview-hide',
        meta: {
          title: 'pageTitles.routes.interviews.root',
          is_adaptive: true,
          isOuter: true
        }
      },
      {
        path: 'open',
        component: visibility,
        name: 'interview-open',
        meta: {
          title: 'pageTitles.routes.interviews.root',
          is_adaptive: true,
          isOuter: true
        }
      },
      {
        path: 'refuse',
        component: refuse,
        name: 'interview-refuse',
        meta: {
          title: 'pageTitles.routes.interviews.root',
          is_adaptive: true,
          refuse: true,
          isOuter: true
        }
      },
      {
        path: 'feedback',
        component: videoresumeFeedback,
        name: 'interview-videoresume-feedback',
        meta: {
          title: 'pageTitles.routes.interviews.root',
          is_adaptive: true,
          isOuter: true
        }
      }
    ]
  },
  {
    path: '/interview-video-result',
    name: 'InterviewVideoResult',
    component: InterviewVideoResult,
    meta: {
      title: 'pageTitles.routes.online-interview.root',
      headerOptions: { fixed: false },
      isOuter: true
    }
  }
];
